import { ConfigurableCard } from "../components/ConfigurableCard";
import { useTemplateContext } from "../provider";
import { VerificationNames } from "shared/types";

export const BankVerificationSlice = () => {
  const { readOnly, template, partnerType, setTemplate, verifiedIncome } =
    useTemplateContext();

  if (!template) return null;

  const verificationSchemas = template.verification_schemas[partnerType];

  const verifiedIncomeVerificationSchema =
    verificationSchemas[VerificationNames.VerifiedIncomeVerification];

  const isVerificationEnabled =
    Boolean(verificationSchemas[VerificationNames.IncomeVerification]) &&
    Boolean(verifiedIncomeVerificationSchema);

  const askCustomer =
    Boolean(verifiedIncomeVerificationSchema) &&
    "allow_bank" in (verifiedIncomeVerificationSchema || {})
      ? verifiedIncomeVerificationSchema?.["allow_bank"]
      : verifiedIncome["allow_bank"];

  const toggleBankEnabled = () => {
    setTemplate({
      ...template,
      verification_schemas: {
        ...template.verification_schemas,
        [partnerType]: {
          ...template.verification_schemas[partnerType],
          [VerificationNames.VerifiedIncomeVerification]: {
            ...verifiedIncomeVerificationSchema,
            allow_bank: !askCustomer
          }
        }
      }
    });
  };

  return (
    <ConfigurableCard
      title="Bank verification"
      rightElement={<img src="/assets/plaid_logo.svg" alt="Plaid logo" />}
      switchProps={{
        checked: Boolean(askCustomer),
        onChange: toggleBankEnabled,
        disabled: !isVerificationEnabled || readOnly,
        label: "Allow verification via bank connection"
      }}
    />
  );
};
